import React, { useState, useEffect } from 'react';
import { Collapse } from 'react-bootstrap';
import Loading from '../../../../common/Loading';
import { useParams } from 'react-router-dom';
import clinicService from '../../../../../services/clinic.service';
import LinksCard from './LinksCard';
import AddLinksForm from './AddLinksForm';
function Links() {
    const [loading, setLoading] = useState(false);
    const { clinicId } = useParams();
    const [linkArray, setLinkArray] = useState([]);
    const [addNew, setAddNew] = useState(false);

    useEffect(() => {
        getLinks();
    }, [clinicId]);

    const handleAddClick = () => {
        setAddNew(!addNew);
    };

    const getLinks = () => {
        setLoading(true);
        clinicService
            .getReputationLinks(clinicId)
            .then((res) => {
                setLinkArray(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    const activeCount = linkArray.filter((link) => link.isActive).length;

    return (
        <div className="notifications-panel">
            <div className="notifications-panel__header justify-content-between flex-wrap gap-2">
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-link-45deg"></i>
                    Reputation Links
                    {!loading && linkArray.length > 0 && (
                        <span className="text-muted small fw-normal">
                            ({activeCount} active / {linkArray.length} total)
                        </span>
                    )}
                </span>
                <button type="button" className={`btn btn-sm ${addNew ? 'btn-outline-danger' : 'btn-outline-primary'}`} onClick={handleAddClick}>
                    <i className={`bi ${addNew ? 'bi-x-lg' : 'bi-plus-lg'} me-1`}></i>
                    {addNew ? 'Cancel' : 'Add Link'}
                </button>
            </div>

            <div className="notifications-panel__body">
                <Collapse in={addNew}>
                    <div className="mb-3">
                        <AddLinksForm clinicid={clinicId} getLinks={getLinks} onCancel={() => setAddNew(false)} existingLinks={linkArray} />
                    </div>
                </Collapse>

                {loading ? (
                    <Loading />
                ) : Array.isArray(linkArray) && linkArray.length > 0 ? (
                    <div className="reputation-link-grid">
                        {linkArray.map((linkitem) => (
                            <LinksCard key={linkitem.id} linkitem={linkitem} getLinks={getLinks} />
                        ))}
                    </div>
                ) : (
                    <div className="reputation-empty">
                        <i className="bi bi-link-45deg"></i>
                        No reputation links configured.
                        {!addNew && (
                            <div className="mt-3">
                                <button type="button" className="btn btn-outline-primary btn-sm" onClick={handleAddClick}>
                                    <i className="bi bi-plus-lg me-1"></i>
                                    Add First Link
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Links;
